// extracted by mini-css-extract-plugin
export default {"aboutText":"about_aboutText__-aIHg","lastLi":"about_lastLi__Bnl0K"};